/* eslint-disable camelcase */
import React from 'react'
import { SwiperSlide } from 'swiper/react'
import { func, object, string, bool, array } from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { getImageOrDefaultSrc, urlWithTrack } from '../../../helpers/common'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../../utils/constants'
import Image from '../../ui/image/Image'
import AdSwiper from '../../ui/ad-swiper/AdSwiper'
import AdLink from '../../ui/ad-link/AdLink'
import SaveButton from '../../ui/button/SaveButton'
import { manufacturerMessages as messages } from '../messages'
import Insights from '../Insights'

const Company = ({
  insights = EMPTY_OBJECT,
  item = EMPTY_OBJECT,
  classes,
  isBig,
  handleLinkClick,
  images = EMPTY_ARRAY,
  type,
  gridView
}) => {
  const { featured_images, products = EMPTY_ARRAY, url, title } = item
  const productsLength = products.length
  const productsShorted = productsLength && products.slice(0, 5)
  const featured_image = featured_images ? isBig ? featured_images.url_large : featured_images.url_medium : ''
  const imageCompany = images.length === 1 ? isBig ? images[0].url_large : images[0].url_medium : ''
  const trackedUrl = urlWithTrack(url, type)
  const saveButtonImage = productsLength && productsShorted.length > 0 ? productsShorted[0].featured_image : featured_image

  // put logo image in last position
  productsShorted && productsShorted.splice(-1, 0, { featured_image, isCompany: true })

  return (
    <Insights className={`gridview__item ${classes}`} {...insights}>
      {
        products && products.length > 1 ? (
          <AdSwiper isLazy>
            {productsShorted.map((product, index) => (
              <SwiperSlide key={index} lazy='true' >
                <div className='gridview__image-wrapper gridview__image-company gridview__company'>
                  {index === productsShorted.length - 1 ? (
                    <AdLink
                      className='gallery-link'
                      href={trackedUrl + '/#products-box'}
                      style={{ backgroundImage: `url(${getImageOrDefaultSrc(product.featured_image)})` }}
                      onClick={handleLinkClick}
                    >
                      <span className='gallery-link__overlay' />
                      <span className='gallery-link__content'>
                        <span className='afd-table-display afd-table-display--center'>
                          <span className='gallery-link__size afd-cell-display'>{'+ ' + productsLength}</span>
                        </span>
                      </span>
                    </AdLink>
                  ) : product.hasOwnProperty('isCompany') ? (
                    <AdLink className='gridview__company-featured' onClick={handleLinkClick} href={trackedUrl}>
                      <Image className='gridview__image-contain swiper-lazy' src={featured_image} loading='lazy' crop={false} />
                    </AdLink>
                  )
                    : (
                      <AdLink href={urlWithTrack(product.url, type)} onClick={handleLinkClick}>
                        <Image className='swiper-lazy'
                          loading='lazy'
                          src={isBig && product.featured_images ? product.featured_images.url_large : product.featured_image}
                          data-object-fit='cover' isBig={isBig} />
                      </AdLink>
                    )}
                </div>
              </SwiperSlide>
            ))}
          </AdSwiper>
        )
          : (
            <div className='gridview__image-wrapper gridview__image-company'>
              <AdLink href={trackedUrl} onClick={handleLinkClick}>
                <Image className='gridview__image-contain' src={imageCompany} crop={false} />
              </AdLink>
            </div>
          )
      }

      <SaveButton title={title} image={saveButtonImage} url={url} gridView={gridView} insights={insights} />

      <AdLink href={trackedUrl} onClick={handleLinkClick} className='gridview__content'>
        {/* type */}
        <div className='gridview__text'>
          <FormattedMessage {...messages.manufacturer} />
        </div>
        {/* manufacturer */}
        <p className='gridview__entry-title'>
          {title}
        </p>
      </AdLink>
    </Insights>
  )
}

Company.propTypes = {
  handleLinkClick: func,
  item: object,
  insights: object,
  isBig: bool,
  classes: string,
  images: array,
  type: string,
  gridView: bool
}

export default React.memo(Company)